export const LOGIN_USER_SUCCEEDED = 'LOGIN_USER_SUCCEEDED';
export const LOGIN_USER_FAILED = 'LOGIN_USER_FAILED';
export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';

export const SET_CURRENT_LOCALE = 'SET_CURRENT_LOCALE';
